interface Parameters {
  baseUrl?: URL | string
  pathname: string
  searchParams: URLSearchParams | Record<string, string | string[]>
}

const appendSearchParamsToPathname = ({ baseUrl = new URL('http://placehold.er'), pathname, searchParams }: Parameters): string => {
  const url = new URL(baseUrl)

  let inputSearchParameters: Record<string, string | string[]> = {}

  switch (true) {
    case searchParams instanceof URLSearchParams:
      inputSearchParameters = {
        ...Object.fromEntries(searchParams as URLSearchParams),
      }
      break
    default:
      inputSearchParameters = searchParams as Record<string, string | string[]>
      break
  }

  const actualSearchParameters = {
    ...Object.fromEntries(new URLSearchParams(url.search)),
    ...inputSearchParameters,
  }

  Object.entries(actualSearchParameters).forEach(([key, value]) => {
    if (typeof value === 'undefined') {
      return
    }

    if (Array.isArray(value) && value.length > 1) {
      url.searchParams.set(key, value.join(','))
    } else {
      url.searchParams.set(key, value.toString())
    }
  })

  url.pathname = pathname

  return url.href.replace(url.origin, '')
}

export { appendSearchParamsToPathname }
